import React, {useEffect, useState} from 'react';
import "../css/settings.css"
import "../css/helpers.css"
import $api from "../http";
import BanksTable from "./helpers/BanksTable";
import ModalBankAdder from "./helpers/ModalBankAdder";
import ModalDialog from "./ModalDialog";
import {transaction} from "mobx";
import {addDevidersToString} from "./helpers/helper-functions";


const Settings = ({store, merchants, traders}) => {


    const [activeBankAdder, setActiveBankAdder] = useState("no")
    const [activeMerchantBatch, setActiveMerchantBatch] = useState("no")
    const [activeDebtModal, setActiveDebtModal] = useState("no")
    const [activeModalInfo, setActiveModalInfo] = useState("no")

    const [modalMessage, setModalMessage] = useState("")

    const [merchantOptions, setMerchantOptions] = useState([])
    const [merchantList, setMerchantList] = useState([])


    const [usdtPriceBybit, setUsdtPriceBybit] = useState(0)
    const [usdtFreshPriceBybit, setUsdtFreshPriceBybit] = useState()

    const [usdtPriceGarantex, setUsdtPriceGarantex] = useState(0)
    const [usdtFreshPriceGarantex, setUsdtFreshPriceGarantex] = useState()

    const [stopCrane, setStopCrane] = useState(false)
    const [manualConfirmsLimit, setManualConfirmsLimit] = useState(0)
    const [newManualConfirmsLimit, setNewManualConfirmsLimit] = useState()

    const [newBank, setNewBank] = useState({name: "", code: "", signatures: "", transgran: false})
    const [banks, setBanks] = useState([])


    const [errorMessage, setErrorMessage] = useState({show: false, target: "", message: ""})



    const [debtorIndex, setDebtorIndex] = useState(null);
    const [debtorToPayOff, setDebtorToPayOff] = useState({});

    const [hashOfPayOff, setHashOfPayOff] = useState();

    const payOffTheDebt = async (hashOfDebt, hashOfPayOff) => {


        try {

            const response = await $api.get(`/pay_off_the_debt?hash_of_debt=${hashOfDebt}&hash_of_pay_off=${hashOfPayOff}`)


            console.log(response.data)

            if(response.data.result === "OK") {

                const debtTransactionInfo = response.data.debtTransactionInfo


                if(debtTransactionInfo) {
                    setVerificationData(prev => {

                        const freshUnaccountedTransactions = prev.unaccountedTransactions.map(
                            transaction => {


                                console.log(transaction)
                                if(transaction.hash === hashOfDebt) {
                                    return debtTransactionInfo
                                } else {
                                    return transaction
                                }
                            }
                        )

                        return {
                            ...prev,
                            unaccountedTransactions: freshUnaccountedTransactions
                        }
                    })

                    const paidOffValue = response.data.paidOffValue

                    if(paidOffValue) {
                        setDebtTotalAmount(prev => prev - parseFloat(paidOffValue))
                    }


                }



            } else {

                setModalMessage(response.data.message)
                setActiveModalInfo("progress")
                setTimeout(() => {
                    setActiveModalInfo("active")
                }, 100)

            }
        } catch (e) {
            setModalMessage(e.message)
            setActiveModalInfo("progress")
            setTimeout(() => {
                setActiveModalInfo("active")
            }, 100)
        }





    }


    const setDebtor = async (hash, debtorId, index) => {


        const response = await $api.get(`/set_debtor_to_transaction?hash=${hash}&debtor_id=${debtorId}`)

        console.log(response.data)

        const transactionData = response.data.transactionData

        if(transactionData) {
            setVerificationData(prev => {

                const freshUnaccountedTransactions = prev.unaccountedTransactions.map(
                    transaction => {


                        console.log(transaction)
                        if(transaction.hash === transactionData.hash) {
                            return transactionData
                        } else {
                            return transaction
                        }
                    }
                )

                return {
                    ...prev,
                    unaccountedTransactions: freshUnaccountedTransactions
                }
            })


            setDebtorIndex(index)
            setTimeout(() => {
                setDebtorIndex()
            }, 2000)



        }


    }

    // Состояние для отслеживания нажатой кнопки копирования
    const [copiedHashIndex, setCopiedHashIndex] = useState(null);
    const [copiedAddressIndex, setCopiedAddressIndex] = useState(null);

    const handleCopy = (id, purpose, index) => {
        navigator.clipboard.writeText(id);

        if(purpose === "hash") {
            setCopiedHashIndex(index);
        } else {
            setCopiedAddressIndex(index)
        }


        // setTimeout(() => setCopiedIndex(null), 2000); // Возвращаем текст обратно через 2 секунды
    };


    const getBanks = async () => {
        const response = await $api.get('/get_banks')
        console.log(response.data)
        setBanks(response.data)

    }


    const [loadingVerification, setLoadingVerification] = useState(false)


    const [debtTotalAmount, setDebtTotalAmount] = useState()
    const [creditTotalAmount, setCreditTotalAmount] = useState()

    const getBalanceAndWalletVerification = async () => {

        setLoadingVerification(true)

        const response = await $api.get('/get_balance_and_wallet_verification')

        console.log(response.data)
        setVerificationData(response.data)
        setLoadingVerification(false)


        const totalDebt = response.data?.unaccountedTransactions.reduce((acc, current) => {

            if(current) {
                acc += current.debt || current.amount
                return acc
            }

            return acc


        }, 0)



        const totalCredit = response.data?.unaccountedIncoming.reduce((acc, current) => {

            if(current) {
                acc += current.amount
                return acc
            }

            return acc


        }, 0)

        setDebtTotalAmount(totalDebt)
        setCreditTotalAmount(totalCredit)

    }

    const [refreshVerification, setRefreshVerification] = useState(0)
    const [verificationData, setVerificationData] = useState({})

    useEffect(() => {

        getBalanceAndWalletVerification()

    }, [refreshVerification])



    const batchMerchantAdding = async (direction, merchantList) => {


        console.log("direction", direction)
        console.log("merchantList", merchantList)

        const response = await $api.post('/batch_merchant_adding', {merchantList, direction})
        setBanks(response.data)

    }


    const getUsdtPrice = async () => {
        const response = await $api.get('/get_ustd_price_admin')

        console.log(response.data)

        setUsdtPriceBybit(response.data.usdtPriceBybit)
        setUsdtPriceGarantex(response.data.usdtPriceGarantex)
    }


    const getStopCrane = async () => {

        const response = await $api.get('/get_stop_crane')

        console.log(response.data)

        setStopCrane(response.data)

    }


    const manualConfirmsLimitSetter = async (value) => {


        console.log("Start request with", value)

        const response = await $api.post('/set_manual_confirms_limit', {value})

        console.log(response.data)

        setManualConfirmsLimit(response.data)
        setNewManualConfirmsLimit("")

    }

    const refreshStopCrane = async (stopCraneState) => {

        const response = await $api.post('/set_stop_crane', {stopCraneState})

        console.log(response.data)

        setStopCrane(response.data)

    }




    const validateFreshUsdtPrice = async (price, exchange) => {


        if(price < 150 && price > 70) {
            refreshUsdtPrice(price, exchange)
        } else {
            setErrorMessage({show: true, target: "usdt", message: "Давайте нормальный курс установим"})
        }

    }


    const refreshUsdtPrice = async (price, exchange) => {

        try {
            const response = await $api.post('/set_usdt_price', {price, exchange})

            if(exchange === "bybit") {
                setUsdtPriceBybit(response.data)
                setUsdtFreshPriceBybit("")
            } else {
                setUsdtPriceGarantex(response.data)
                setUsdtFreshPriceGarantex("")
            }

        } catch (e) {
            setErrorMessage({show: true, message: e.message})
        }


    }


    function validateBankCode(input) {

        const validPattern = /^[A-Za-z-]*$/;
        const valid = validPattern.test(input)

        if(valid) {
            setNewBank(prev => {
                setErrorMessage({show: false})
                return {
                    ...prev,
                    code: input
                }
            })
        }

    }

    const editBank = async (bank) => {

        console.log(bank)

        setNewBank({
            id: bank._id,
            name: bank.name,
            code: bank.code,
            signatures: bank.signatures.join(', '),
            merchants: bank.merchants,
            transgran: bank.transgran,
            allowedSplit: bank.allowedSplit,
            chargeControl: bank.chargeControl,
            geo: bank.geo
        })

        setActiveBankAdder("progress")
        setTimeout(() => {
            setActiveBankAdder("active")
            // setTimerSeconds(seconds ?? 10)
            // setTimerRelease(false)
        }, 300)

    }



    const addBank = async (bank) => {


        console.log(bank)


        if(bank.name && bank.code && bank.signatures && bank.geo) {

            try {
                const response = await $api.post("/add_bank", {...bank})

                console.log(response.data)

                if(response.data.status === "OK") {

                    setNewBank({name: "", code: "", signatures: "", id: "", transgran: false, geo: ""})

                    setErrorMessage({show: true, target: "bank", color: "green", message: "Банк добавлен"})

                    setTimeout(() => {
                        setErrorMessage({show: false})
                    }, 2000)

                    setBanks(prev => {
                        const bankInfo = response.data.bankInfo;

                        // Проверяем, существует ли банк с таким _id в массиве
                        const exists = prev.some(bank => bank._id === bankInfo._id);

                        if (exists) {
                            // Если банк уже существует, обновляем его
                            return prev.map(bank =>
                                bank._id === bankInfo._id ? bankInfo : bank
                            );
                        } else {
                            // Если банк не существует, добавляем его в массив
                            return [bankInfo, ...prev];
                        }
                    });
                } else {
                    setErrorMessage({show: true, target: "bank", message: response.data.message})
                }
            } catch (e) {
                setErrorMessage({show: true, target: "bank", message: e.message})
            }



            setActiveBankAdder("progress")
            setTimeout(() => {
                setActiveBankAdder("no")
                // setTimerSeconds(seconds ?? 10)
                // setTimerRelease(false)
            }, 300)




        } else {
            setErrorMessage({show: true, target: "bank", message: "Не все поля заполнены"})
        }

    }


    const getAllAdminSettings = async () => {
        const response = await $api.get('/get_all_admin_settings')

        console.log(response.data)

        setStopCrane(response.data.stopCrane)
        setBanks(response.data.banks)
        setUsdtPriceBybit(response.data.usdtPriceBybit)
        setUsdtPriceGarantex(response.data.usdtPriceGarantex)
        setManualConfirmsLimit(response.data.manualConfirmsLimit)


        setInterval(() => {
            getUsdtPrice()
        }, 60000)


    }



    useEffect(() => {
        store.setPageTitle("Настройки площадки")
        // getUsdtPriceBybit()
        // getStopCrane()
        // getBanks()
        getAllAdminSettings()


    }, []);


    useEffect(() => {
        const merchantOptionsforSelect = merchants.map(merchant => ({value: merchant._id, label: merchant.login}))

        setMerchantOptions(merchantOptionsforSelect)

    }, [merchants])

    const [showUnaccounted, setShowUnaccounted] = useState(false);


    return (
        <div className={"settings-wrapper"}>
            <div className={"settings-usdt-wrapper"}>
                <div className={"settings-usdt-header"}>
                    <h5 className={"settings-label"}>Настройки USDT</h5>
                    <div className={"settings-error-message-wrapper"}>
                        {errorMessage.show && errorMessage.target === "usdt"
                            ?
                            <h3 className={`settings-error-message ${errorMessage.color === "green" ? "green-text" : "red-text"}`}>{errorMessage.message}</h3>
                            :
                            null
                        }
                    </div>
                </div>

                <div className={"settings-usdt-setter"}>
                    <div className={"settings-usdt-price-monitor"}>
                        Курс площадки (Bybit)
                        <h1 className={"settings-usdt-value"}>{usdtPriceBybit} ₽</h1>
                    </div>
                    <input
                        placeholder={"Новый курс"}
                        value={usdtFreshPriceBybit}
                        onChange={(e) => {
                            setErrorMessage({show: false, target: "", message: ""})
                            setUsdtFreshPriceBybit(e.target.value)
                        }
                        }
                        type={"number"}
                    />
                    <button
                        onClick={() => {
                            validateFreshUsdtPrice(usdtFreshPriceBybit, "bybit")
                        }}
                        className={"gradient-orange-button"}
                    >Установить
                    </button>
                </div>

                <div className={"settings-usdt-setter"}>
                    <div className={"settings-usdt-price-monitor"}>
                        Курс площадки (Rapira)
                        <h1 className={"settings-usdt-value"}>{usdtPriceGarantex} ₽</h1>
                    </div>
                    <input
                        placeholder={"Новый курс"}
                        value={usdtFreshPriceGarantex}
                        onChange={(e) => {
                            setErrorMessage({show: false, target: "", message: ""})
                            setUsdtFreshPriceGarantex(e.target.value)
                        }
                        }
                        type={"number"}
                    />
                    <button
                        onClick={() => {
                            validateFreshUsdtPrice(usdtFreshPriceGarantex, "garantex")
                        }}
                        className={"gradient-orange-button"}
                    >Установить
                    </button>
                </div>

                <div className="settings-current-value-monitor">

                    <div className={"verification-refresh-bnt-n-spinner-container"}>
                        {loadingVerification
                            ? <img src={require('../img/loading.gif')} height={"25px"}
                                   className={"margin-left-20"}/>
                            : null
                        }
                        <button
                            className={'gradient-orange-button'}
                            onClick={() => setRefreshVerification(prev => prev + 1)}
                            style={{
                                alignSelf: 'flex-end',
                                justifySelf: 'flex-start'

                            }}
                        >
                            Обновить
                        </button>
                    </div>
                    <table className="settings-usdt-table">
                        <thead>
                        <tr>
                            <th>Показатель</th>
                            <th>Значение</th>
                        </tr>
                        </thead>
                        <tbody>
                        {Object.entries(verificationData).map(([key, value]) => {
                            if (key !== "unaccountedTransactions" && key !== "unaccountedIncoming") {
                                return (
                                    <tr key={key}>
                                        <td>{key}</td>
                                        <td>{value.toLocaleString()} $</td>
                                    </tr>
                                )
                            }
                        })}
                        <tr>
                            <td>Отдано в долг</td>
                            <td className={"red-bold"}>{addDevidersToString(debtTotalAmount?.toFixed(2))} $</td>
                        </tr>
                        <tr>
                            <td>Неучтенные входящие</td>
                            <td className={"red-bold"}>{addDevidersToString(creditTotalAmount?.toFixed(2))} $</td>
                        </tr>
                        <tr>
                            <td>Свободные средства</td>
                            <td>{(verificationData.mainWalletBalance - (verificationData.traderMass + verificationData.merchantMass + verificationData.teamleadMass) - creditTotalAmount).toLocaleString()} $</td>
                        </tr>

                        <tr>
                            <td>Свободные средства + долги - входящие</td>
                            <td>{(debtTotalAmount + verificationData.mainWalletBalance - (verificationData.traderMass + verificationData.merchantMass + verificationData.teamleadMass) - creditTotalAmount).toLocaleString()} $</td>
                        </tr>


                        </tbody>
                    </table>

                    <button
                        className={'gradient-orange-button'}
                        onClick={() => setShowUnaccounted(!showUnaccounted)}
                        style={{marginTop: '10px'}}
                    >
                        {showUnaccounted ? 'Скрыть неучтённые транзакции' : 'Показать неучтённые транзакции'}
                    </button>

                    <div className={`unaccounted-transactions-container ${showUnaccounted ? 'show' : ''}`}>
                        <h4>Неучтённые исходящие транзакции</h4>
                        <table className="settings-usdt-table">
                            <thead>
                            <tr>
                                <th>Хэш</th>
                                <th>Сумма (USDT)</th>
                                <th>Дата</th>
                                <th>Должник</th>
                                <th>Долг</th>
                                {/*<th>Адрес</th>*/}
                                <th>Погасить</th>
                            </tr>
                            </thead>
                            <tbody>
                            {verificationData.unaccountedTransactions?.map((tx, index) => {

                                if (tx.paid) return

                                return (
                                    <tr key={tx.hash}>
                                        <td>
                                            <button
                                                className="copy-button"
                                                onClick={() => {
                                                    setCopiedAddressIndex()
                                                    handleCopy(tx.hash, "hash", index)
                                                }}
                                            >
                                                {copiedHashIndex === index ? 'Copied' : 'Copy'}
                                            </button>
                                        </td>
                                        <td>{tx.amount.toLocaleString()}</td>
                                        <td>{new Date(tx.date).toLocaleString([], {
                                            year: "numeric",
                                            month: "numeric",
                                            day: "numeric",
                                            hour: '2-digit',
                                            minute: '2-digit'
                                        })}</td>
                                        <td>
                                            <select
                                                value={tx.debtor ?? ""}
                                                onChange={(e) => {
                                                    setDebtor(tx.hash, e.target.value, index)
                                                }}
                                            >
                                                <option value={""}>Нет...</option>
                                                {Object.values(traders)
                                                    .sort((a, b) => a.login.localeCompare(b.login))
                                                    .map(trader => (
                                                        <option key={trader.id} value={trader.id}>
                                                            {trader.login}
                                                        </option>
                                                    ))}

                                            </select>{debtorIndex === index ? "✅" : " "}
                                        </td>
                                        <td>
                                            {tx.debt?.toFixed(2)}
                                        </td>
                                        {/*<td>*/}
                                        {/*    <button*/}
                                        {/*        className="copy-button"*/}
                                        {/*        onClick={() => {*/}
                                        {/*            setCopiedHashIndex()*/}
                                        {/*            handleCopy(tx.receiver, "receiver", index)*/}
                                        {/*        }}*/}
                                        {/*    >*/}
                                        {/*        {copiedAddressIndex === index ? 'Copied' : 'Copy'}*/}
                                        {/*    </button>*/}
                                        {/*</td>*/}
                                        <td>
                                            {tx.debtor ? <button
                                                className={"gradient-green-button"}
                                                onClick={() => {

                                                    const debtor = traders.find((trader) => trader.id === tx.debtor)

                                                    setDebtorToPayOff({
                                                        login: debtor.login,
                                                        amount: tx.amount?.toFixed(2),
                                                        hash: tx.hash
                                                    })
                                                    setActiveDebtModal("progress")
                                                    setTimeout(() => {
                                                        setActiveDebtModal("active")
                                                    }, 100)
                                                }}
                                            >
                                                OK
                                            </button> : null}
                                        </td>
                                    </tr>
                                )
                            })}
                            </tbody>
                            <ModalDialog
                                active={activeDebtModal}
                                setActive={setActiveDebtModal}
                                purpose={"input"}
                                inputPlaceHolder={"Втавьте хэш"}
                                buttonText1={"Погасить"}
                                message={`Вы хотите погасить долг ${debtorToPayOff?.login} в размере ${debtorToPayOff.amount} usdt?`}
                                action={() => payOffTheDebt(debtorToPayOff.hash, hashOfPayOff)}
                                inputValue={hashOfPayOff}
                                setInputValue={setHashOfPayOff}
                                // workState={merchantList}
                                // setWorkState={setMerchantList}

                            />

                            <ModalDialog
                                active={activeModalInfo}
                                setActive={setActiveModalInfo}
                                purpose={"info"}
                                message={modalMessage}
                            />

                        </table>
                        <hr/>
                        <h4>Неучтённые входящие транзакции</h4>
                        <table className="settings-usdt-table">
                            <thead>
                            <tr>
                                <th>Хэш</th>
                                <th>Сумма (USDT)</th>
                                <th>Дата</th>
                                <th>От</th>

                            </tr>
                            </thead>
                            <tbody>
                            {verificationData.unaccountedIncoming?.map((tx, index) => {

                                if (tx.paid) return

                                return (
                                    <tr key={tx.hash}>
                                        <td>
                                            <button
                                                className="copy-button"
                                                onClick={() => {
                                                    setCopiedAddressIndex()
                                                    handleCopy(tx.hash, "hash", index)
                                                }}
                                            >
                                                {copiedHashIndex === index ? 'Copied' : 'Copy'}
                                            </button>
                                        </td>
                                        <td>{tx.amount.toLocaleString()}</td>
                                        <td>{new Date(tx.date).toLocaleString([], {
                                            year: "numeric",
                                            month: "numeric",
                                            day: "numeric",
                                            hour: '2-digit',
                                            minute: '2-digit'
                                        })}</td>
                                        <td>
                                            <button
                                                className="copy-button"
                                                onClick={() => {
                                                    setCopiedHashIndex()
                                                    handleCopy(tx.sender, "sender", index)
                                                }}
                                            >
                                                {copiedAddressIndex === index ? 'Copied' : 'Copy'}
                                            </button>
                                        </td>

                                    </tr>
                                )
                            })}
                            </tbody>
                        </table>
                    </div>

                </div>


            </div>

            <div className={"settings-stop-crane-wrapper"}>
                <div className={"settings-stop-crane-header"}>
                    <h5 className={"settings-label"}>СТОП-КРАН</h5>
                    <div className={"settings-error-message-wrapper"}>
                        {errorMessage.show && errorMessage.target === "stop"
                            ?
                            <h3 className={`settings-error-message ${errorMessage.color === "green" ? "green-text" : "red-text"}`}>{errorMessage.message}</h3>
                            :
                            null
                        }
                    </div>
                </div>

                <div className={"settings-stop-crane-setter"}>

                    <div className="circle-container">
                        <div className={`${stopCrane ? "green-circle" : "red-circle"}`}></div>
                    </div>
                    <div className={"settings-stop-crane-indicator-container"}>
                        <h3 className={`stop-crane-indicator ${stopCrane ? "red-text" : "green-text"}`}>
                            ПЛОЩАДКА {`${stopCrane ? "ОСТАНОВЛЕНА" : "РАБОТАЕТ"}`}
                        </h3>
                        <button
                            className={`${stopCrane ? "gradient-green-button" : "gradient-red-button"} stop-button`}
                            onClick={() => refreshStopCrane(!stopCrane)}
                        >{stopCrane ? "ПУСК" : "СТОП"}</button>
                    </div>


                </div>

            </div>

            <div className={"settings-banks-wrapper"}>
                <div className={"settings-banks-header"}>
                    <ModalBankAdder
                        active={activeBankAdder}
                        setActive={setActiveBankAdder}
                        value={newBank}
                        setValue={setNewBank}
                        action={() => addBank(newBank)}
                        errorMessage={errorMessage}
                        merchantOptions={merchantOptions}
                    />
                    <ModalDialog
                        active={activeMerchantBatch}
                        setActive={setActiveMerchantBatch}
                        purpose={"merchant_batch"}
                        merchantOptions={merchantOptions}
                        message={"Добавить/убрать мерчанта из всех банков"}
                        action={(arg1, arg2) => batchMerchantAdding(arg1, arg2)}
                        workState={merchantList}
                        setWorkState={setMerchantList}

                    />
                    <h5 className={"settings-label"}>Настройки банков</h5>
                    <div className={"settings-error-message-wrapper"}>
                        {errorMessage.show && errorMessage.target === "bank"
                            ?
                            <h3 className={`settings-error-message ${errorMessage.color === "green" ? "green-text" : "red-text"}`}>{errorMessage.message}</h3>
                            :
                            null
                        }
                    </div>
                </div>

                <div className={"settings-bank-adder"}>
                    {/*<input*/}
                    {/*    type={"text"}*/}
                    {/*    placeholder={"Название"}*/}
                    {/*    value={newBank.name}*/}
                    {/*    onChange={(e) => {*/}
                    {/*        setNewBank(prev => {*/}
                    {/*            setErrorMessage({show: false})*/}
                    {/*            return {*/}
                    {/*                ...prev,*/}
                    {/*                name: e.target.value*/}
                    {/*            }*/}
                    {/*        })*/}
                    {/*    }}*/}
                    {/*/>*/}
                    {/*<input*/}
                    {/*    type={"text"}*/}
                    {/*    placeholder={"код"}*/}
                    {/*    value={newBank.code}*/}
                    {/*    onChange={(e) => validateBankCode(e.target.value)}*/}
                    {/*/>*/}
                    <button
                        className={"gradient-orange-button"}
                        onClick={() => {
                            setActiveBankAdder("progress")
                            setTimeout(() => {
                                setActiveBankAdder("active")
                                // setTimerSeconds(seconds ?? 10)
                                // setTimerRelease(false)
                            }, 300)
                        }}
                    >Добавить
                    </button>

                    <button
                        className={"gradient-orange-button"}
                        onClick={() => {
                            setActiveMerchantBatch("progress")
                            setTimeout(() => {
                                setActiveMerchantBatch("active")
                                // setTimerSeconds(seconds ?? 10)
                                // setTimerRelease(false)
                            }, 300)
                        }}
                    >Пакетное добавление
                    </button>

                </div>

                <BanksTable banks={banks} editBank={editBank}/>

            </div>

            <div className={"settings-limits-wrapper"}>
                <h5 className={"settings-label"}>Установки лимитов</h5>
                <div className={"limit-wrapper"}>
                    <label>Ручные подтверждения</label>
                    <div className={"settings-current-value-monitor"}>
                        <h2 className={"margin-0"}>{manualConfirmsLimit}</h2>
                    </div>
                    <input
                        type={"number"}
                        value={newManualConfirmsLimit}
                        onChange={(e) => setNewManualConfirmsLimit(e.target.value)}
                    />
                    <button
                        className={"gradient-orange-button"}
                        onClick={() => {
                            manualConfirmsLimitSetter(newManualConfirmsLimit)
                        }}
                    >Установить</button>
                </div>

            </div>

        </div>
    );
};

export default Settings;